import React from 'react';

const Footer = () => {
    return (
        <div>
            <footer className='footer'>ⓒ Arif Hossain 2023</footer>
        </div>
    );
};

export default Footer;